import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const BROWN      = [109, 78, 54];
const BROWN_LIGHT = [245, 237, 228];
const WHITE      = [255, 255, 255];
const GRAY_LINE  = [200, 185, 170];

export const generatePointageJournalierPDF = ({
  chantierName,
  userName,
  date,
  dataTable
}) => {
  const now = new Date();
  const currentDate = now.toLocaleDateString('fr-FR');
  const currentTime = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

  const doc = new jsPDF();
  const pageW = doc.internal.pageSize.width;

  // ── Bandeau titre ───────────────────────────────────────────────
  doc.setFillColor(...BROWN);
  doc.rect(0, 0, pageW, 28, 'F');

  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...WHITE);
  doc.text('POINTAGE JOURNALIER', pageW / 2, 12, { align: 'center' });

  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.text(`Chantier : ${chantierName}`, pageW / 2, 21, { align: 'center' });

  // ── Bloc info ───────────────────────────────────────────────────
  doc.setFillColor(...BROWN_LIGHT);
  doc.roundedRect(14, 32, pageW - 28, 22, 3, 3, 'F');
  doc.setDrawColor(...GRAY_LINE);
  doc.roundedRect(14, 32, pageW - 28, 22, 3, 3, 'S');

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...BROWN);
  doc.text(`Date :`, 20, 40);
  doc.text(`Pointeur :`, 80, 40);
  doc.text(`Saisi le :`, 148, 40);

  doc.setFont('helvetica', 'normal');
  doc.setTextColor(30, 30, 30);
  doc.text(date, 35, 40);
  doc.text(userName, 101, 40);
  doc.text(`${currentDate} à ${currentTime}`, 163, 40);

  // ── Statistiques ────────────────────────────────────────────────
  const pointedRows = dataTable.filter(r => Number(r.jours) > 0 || Number(r.heures) > 0);
  const totalJours  = pointedRows.reduce((s, r) => s + Number(r.jours  || 0), 0);
  const totalHeures = pointedRows.reduce((s, r) => s + Number(r.heures || 0), 0);

  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...BROWN);
  doc.setFontSize(10);
  doc.text(`Ouvriers pointés : ${pointedRows.length}`, 20, 50);
  doc.text(`Total jours : ${totalJours}`, 80, 50);
  doc.text(`Total heures : ${totalHeures}`, 148, 50);

  // ── Tableau ─────────────────────────────────────────────────────
  doc.setTextColor(0, 0, 0);

  if (pointedRows.length === 0) {
    doc.setFontSize(12);
    doc.setFont('helvetica', 'italic');
    doc.setTextColor(150, 150, 150);
    doc.text('Aucun ouvrier pointé pour cette date.', pageW / 2, 75, { align: 'center' });
  } else {
    const rows = pointedRows.map((row, i) => [
      i + 1,
      row.cin  || '—',
      row.name || '—',
      row.qualification || '—',
      Number(row.jours  || 0),
      Number(row.heures || 0)
    ]);

    autoTable(doc, {
      startY: 60,
      head: [['#', 'CIN', 'Nom complet', 'Qualification', 'Jours', 'Heures']],
      body: rows,
      theme: 'grid',
      styles: {
        fontSize: 9,
        halign: 'center',
        cellPadding: 3,
        textColor: [30, 30, 30],
        lineColor: GRAY_LINE,
        lineWidth: 0.3
      },
      headStyles: {
        fillColor: BROWN,
        textColor: WHITE,
        fontStyle: 'bold',
        fontSize: 10
      },
      bodyStyles:          { fillColor: WHITE },
      alternateRowStyles:  { fillColor: BROWN_LIGHT },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 30 },
        2: { cellWidth: 50 },
        3: { cellWidth: 40 },
        4: { cellWidth: 18 },
        5: { cellWidth: 18 }
      },
      didDrawPage: (data) => {
        const ph = doc.internal.pageSize.height;

        // Ligne de séparation footer
        doc.setDrawColor(...GRAY_LINE);
        doc.line(14, ph - 38, pageW - 14, ph - 38);

        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(80, 80, 80);
        doc.text('Signature Responsable : ____________________', 14, ph - 30);
        doc.text('Observations : ________________________________', 14, ph - 20);

        // Numéro de page
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(8);
        doc.setTextColor(160, 160, 160);
        doc.text(
          `Page ${data.pageNumber} / ${pageCount}  —  ${currentDate} ${currentTime}`,
          pageW - 14, ph - 8, { align: 'right' }
        );
      }
    });
  }

  const filename = `Pointage_${chantierName.replace(/\s+/g, '_')}_${date}.pdf`;
  doc.save(filename);
  window.open(doc.output('bloburl'), '_blank');
};
